export const AESTHETIC_MODULES = {
  PRODUCTION_PHASES: 1,
  SERVICES: 2,
  PACKAGES: 3,
};
